<template>
	<div class="container">
		<div class="tags-container">
			<div
				v-for="(item, index) in tags"
				:key="index + '-only'"
				class="tagNone"
				:class="tagTitle"
			>
				{{ item.name }}
			</div>
			<div class="radioTitle">{{ tagTitle }}：</div>
			<div
				v-for="(item, index) in visibleTags"
				:key="index"
				class="tag"
				:class="{ active: isActive(item) }"
				@click="tagClick(item)"
			>
				{{ item.name }}
			</div>
			<div
				v-if="showToggle"
				class="toggle-button tagMore"
				@click="toggleShowMore"
			>
				<span style="margin-right: 5px">更多...</span>
				<span
					class="showMoreBorder"
					:style="{ lineHeight: showMore ? '12px' : '16px' }"
					>{{ showMore ? '-' : '+' }}</span
				>
			</div>
		</div>
		<div class="tags-container" v-if="showMore">
			<div
				v-for="(item, index) in hiddenTags"
				:key="'more-' + index"
				class="tag"
				:class="{ active: isActive(item) }"
				@click="tagClick(item)"
			>
				{{ item.name }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TagsComponent',
	props: {
		tags: {
			type: Array,
			required: true,
		},
		selectedTags: {
			type: Array,
			default: () => [],
		},
		tagTitle: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			containerWidth: 740,
			showMore: false,
			visibleTags: [],
		};
	},
	computed: {
		hiddenTags() {
			return this.tags.slice(this.visibleTags.length);
		},
		showToggle() {
			return this.hiddenTags.length > 0;
		},
	},
	mounted() {
		this.visibleTagsMounth();
	},
	methods: {
		tagClick(tag) {
			this.$emit('tag-click', tag);
		},
		isActive(tag) {
			for (let index = 0; index < this.selectedTags.length; index++) {
				const element = this.selectedTags[index];
				if (element.type == tag.type && tag.name == element.name) {
					return true;
				}
			}
		},
		toggleShowMore() {
			this.showMore = !this.showMore;
		},
		visibleTagsMounth() {
			let totalWidth = 0;
			for (let i = 0; i < this.tags.length; i++) {
				const tag = this.tags[i];
				const tagWidth =
					document.getElementsByClassName(this.tagTitle)[i]
						.clientWidth + 0;

				if (totalWidth + tagWidth <= this.containerWidth) {
					this.visibleTags.push(tag);
					totalWidth += tagWidth;
				} else {
					break; // 超过容器宽度时停止添加标签
				}
			}
		},
	},
};
</script>

<style scoped lang="less">
.container {
	width: 865px;
	overflow: hidden;
}

.tags-container {
	display: flex;
	flex-wrap: wrap;
	position: relative;
	font-size: 14px !important;
	.radioTitle {
		font-weight: 600;
		padding: 12px 0;
	}
}
.tagNone {
	height: 0;
	opacity: 0;
	position: absolute;
	z-index: -1;
	padding: 12px 10px;
	font-size: 14px !important;
}
.tag {
	padding: 12px 10px;
	color: rgba(34, 34, 34, 1);
	cursor: pointer;
	user-select: none;
	transition: color 0.3s;
}
.tagMore {
	padding: 12px 0 !important;
}
.tag:hover {
	color: rgba(54, 163, 82, 1);
}

.tag.active {
	color: rgba(54, 163, 82, 1);
}

.toggle-button {
	margin-left: auto;
	padding: 10px;
	color: #6c757d;
	cursor: pointer;
	user-select: none;
	transition: color 0.3s;
	display: flex;
	.showMoreBorder {
		width: 15px;
		height: 15px;
		display: inline-block;
		line-height: 16px;
		text-align: center;
		font-size: 20px;
		border: 1px solid #b2b2b2;
	}
}

.toggle-button:hover {
	color: #007bff;
}

.selected-tags {
	margin-top: 10px;
	display: flex;
	flex-wrap: wrap;
}

.el-tag {
	margin-right: 5px;
	margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/dynamicInfo/downPull.vue